module.exports = __webpack_public_path__ + "static/media/bank.329450df.svg";